import { BehaviorSubject } from 'rxjs';
import { GoogleMapsState } from './google-maps.state';
import { GoogleMapsStateReadyFactory } from './factories/google-maps.ready-state.factory';
import { GoogleMap } from '@capacitor/google-maps';
import { GoogleMapConfigFactory } from './factories/google-maps.config.factory';

export class GoogleMapsViewModel {
  private _state = new BehaviorSubject<GoogleMapsState.Spec>(new GoogleMapsState.Init());
  state = this._state.asObservable();

  constructor(
    private googleMapsStateReadyFactory: GoogleMapsStateReadyFactory,
    private configFactory: GoogleMapConfigFactory
  ) {}

  public async initiateMap(enableCurrentLocation: boolean): Promise<void> {
    const config = await this.configFactory.create(enableCurrentLocation);
    const state = new GoogleMapsState.Loading(config);

    await this.shutdownIfReady(this._state.value);
    this._state.next(state);
  }

  public async onMapLoaded(map: GoogleMap) {
    const state = await this.googleMapsStateReadyFactory.create(map);
    this._state.next(state);
  }

  public async onCleanUp() {
    await this.shutdownIfReady(this._state.value);
    this._state.next(new GoogleMapsState.Shutdown());
  }

  private async shutdownIfReady(state: GoogleMapsState.Spec) {
    if (state instanceof GoogleMapsState.Ready) {
      await state.shutdownController.shutdown();
    }
  }
}
